import React from 'react';
import { Result, Button } from 'antd';

class MultichoixErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('MultichoixErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    this.props.onReset?.();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container px-4 py-8">
          <Result
            status="error"
            title="Une erreur est survenue"
            subTitle={this.state.error?.message || 'Erreur inattendue lors du chargement de la recherche multichoix.'}
            extra={[
              <Button type="primary" key="reset" onClick={this.handleReset}>
                Réessayer
              </Button>,
              <Button key="home" href="/traitement/">
                Retour à la recherche
              </Button>,
            ]}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default MultichoixErrorBoundary;
